(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

// Account Dropdown - Hybrid Click/Hover Implementation
document.addEventListener('DOMContentLoaded', function() {
  const accountDropdownContainer = document.querySelector('.header__account-dropdown');
  const accountTrigger = document.querySelector('.header__account-dropdown .header__icon--account');
  const accountMenu = document.querySelector('.header__account-menu');
  const accountOverlay = document.querySelector('.header__account-overlay');
  
  if (accountDropdownContainer && accountTrigger && accountMenu && accountOverlay) {
    let hoverTimeout;
    let isMenuHovered = false;
    let isDropdownHovered = false;
    let openedByClick = false;
    let isDropdownOpen = false;
    
    // Show dropdown function
    const showDropdown = () => {
      clearTimeout(hoverTimeout);
      accountOverlay.classList.add('active');
      accountMenu.style.opacity = '1';
      accountMenu.style.visibility = 'visible';
      accountMenu.style.transform = 'translateY(0)';
      isDropdownOpen = true;
    };
    
    // Hide dropdown function
    const hideDropdown = (force = false) => {
      // If opened by click and not forcing close, don't hide on hover out
      if (openedByClick && !force) return;
      
      hoverTimeout = setTimeout(() => {
        if (!isMenuHovered && !isDropdownHovered || force) {
          // Only remove overlay if no mega menu is open
          if (!document.querySelector('.mega-menu[open]')) {
            accountOverlay.classList.remove('active');
          }
          accountMenu.style.opacity = '';
          accountMenu.style.visibility = '';
          accountMenu.style.transform = '';
          isDropdownOpen = false;
          openedByClick = false;
        }
      }, force ? 0 : 300);
    };
    
    // Click event for the trigger link only
    accountTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (!isDropdownOpen) {
        openedByClick = true;
        showDropdown();
      } else {
        // If already open, navigate to account page
        const accountUrl = this.getAttribute('href');
        if (accountUrl) {
          window.location.href = accountUrl;
        }
      }
    });
    
    // Mouse events for dropdown container (desktop hover)
    accountDropdownContainer.addEventListener('mouseenter', () => {
      isDropdownHovered = true;
      if (!openedByClick) {
        showDropdown();
      }
    });
    
    accountDropdownContainer.addEventListener('mouseleave', () => {
      isDropdownHovered = false;
      if (!openedByClick) {
        hideDropdown();
      }
    });
    
    // Mouse events for menu itself
    accountMenu.addEventListener('mouseenter', () => {
      isMenuHovered = true;
      clearTimeout(hoverTimeout);
    });
    
    accountMenu.addEventListener('mouseleave', () => {
      isMenuHovered = false;
      if (!openedByClick) {
        hideDropdown();
      }
    });
    
    // Prevent clicks inside menu from closing it
    accountMenu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    // Click overlay to close
    accountOverlay.addEventListener('click', () => {
      hideDropdown(true);
    });
    
    // Click outside to close
    document.addEventListener('click', (e) => {
      if (isDropdownOpen && !accountDropdownContainer.contains(e.target) && !accountMenu.contains(e.target)) {
        hideDropdown(true);
      }
    });
    
    // Touch events for better mobile/tablet support
    let touchStartY = 0;
    
    accountTrigger.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    accountTrigger.addEventListener('touchend', (e) => {
      const touchEndY = e.changedTouches[0].clientY;
      const touchDistance = Math.abs(touchEndY - touchStartY);
      
      // Only trigger click if it wasn't a scroll gesture
      if (touchDistance < 10) {
        e.preventDefault();
        accountTrigger.click();
      }
    });
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDropdownOpen) {
        hideDropdown(true);
        accountTrigger.focus(); // Return focus to trigger
      }
    });
    
    // Handle focus for accessibility
    accountTrigger.addEventListener('focus', () => {
      if (!openedByClick && !isDropdownOpen) {
        showDropdown();
      }
    });
    
    // Close dropdown when focusing outside
    document.addEventListener('focusin', (e) => {
      if (isDropdownOpen && 
          !accountDropdownContainer.contains(e.target) && 
          !accountMenu.contains(e.target)) {
        hideDropdown(true);
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
